/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Automation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CreateAction from './CreateAction/index'
import EditAction from './EditAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Automation({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/AutomationsTable/Automation"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let automationNameValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'name',
})
let automationDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'description',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let automationIsEnabledValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'is_enabled',
})
  return (<React.Fragment
>
<div
  data-testid="Automation.Horizontal"
  data-view-path={viewPath}
 style={{'--mb-1-Z2jmc2o': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Automation.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 data="automation.name"
 text={automationNameValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral600}
 data="automation.description"
 text={automationDescriptionValueData}
/>
</div>
<div
  data-testid="Automation.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={automationIsEnabledValueData ? "Yes" : "No"}
 data="automation.is_enabled"
/>
</div>
<div
  data-testid="Automation.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<EditAction
  viewPath={`${viewPath}/EditAction`}
/>
<CreateAction
  viewPath={`${viewPath}/CreateAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}